// src/stores/auth.js
import { defineStore } from 'pinia';
import axios from '@/plugins/axios'; // Configura tu instancia de Axios con baseURL


export const useCategoriesStore = defineStore('categories', {
 state: () => ({
    companies: [],
    centers: [],
    departments: [],
  }),
  actions: {
    async fetchCategories() {
      try {
        const response = await axios.get('/retrive/categories');
        this.companies = response.data.companies;
        this.centers = response.data.centers;
        this.departments = response.data.departments;
      } catch (error) {
        console.error('Error fetching categories:', error.message);
      }
    },

    async addContact(contact) {
        try {
          await axios.post('/contact/add', contact);
        } catch (error) {
          console.error('Error adding contact:', error.message);
          throw error; // Permite que el componente capture y maneje el error
          
        }
    },

    async updateContact(contact) {
      try {
          const response = await axios.put(`/contact/update/${contact.id}`, contact);
          return response.data;
      } catch (error) {
          console.error('Error updating contact:', error.message);
          throw error;
      }
  },

  async deleteContact(id){
    try {
     const response =  await axios.delete(`/contact/delete/${id}`);
     return response;
    } catch (error) {
      console.error('Error deleting contact:', error.message);
      throw error;
    }
  },


  // Agregar una nueva empresa
  async addCompany(company) {
    try {
      const response = await axios.post('/companies', company);
      this.companies.push(response.data); // Agregar la nueva empresa a la lista
    } catch (error) {
      console.error('Error adding company:', error.message);
      throw error;
    }
  },

  // Actualizar una empresa
  async updateCompany(company) {

    console.log(company, 'Updating company');
    try {
      const response = await axios.put(`/companies/${company.id}`, company);
      // Actualizar la empresa en la lista
      const index = this.companies.findIndex((c) => c.id === company.id);
      if (index !== -1) {
        this.companies[index] = response.data;
      }
    } catch (error) {
      console.error('Error updating company:', error.message);
      throw error;
    }
  },


  async deleteCompany(id) {
    try {
        const response = await axios.delete(`/companies/${id}`);
        return response.data;
    } catch (error) {
        // Manejo de errores con mensaje claro
        if (error.response && error.response.data) {
            // Incluye el mensaje y el estado en el error lanzado
            throw new Error(error.response.data.message || "Error desconocido del servidor");
        } else {
            // Lanza un error genérico si no hay respuesta del backend
            throw new Error("Error de conexión con el servidor");
        }
    }
},



//  Funciones del centro  

 // Agregar una nuevo centro
 async addCenter(center) {
  try {
    const response = await axios.post('/center', center);
    this.centers.push(response.data); // Agregar la nueva empresa a la lista
  } catch (error) {
    console.error('Error adding center:', error.message);
    throw error;
  }
},

// Actualizar un centro
async updateCenter(center) {
  try {
    const response = await axios.put(`/center/${center.id}`, center);
    // Actualizar la empresa en la lista
    const index = this.centers.findIndex((c) => c.id === center.id);
    if (index !== -1) {
      this.centers[index] = response.data;
    }
  } catch (error) {
    console.error('Error updating center:', error.message);
    throw error;
  }
},


async deleteCenter(id) {
  try {
      const response = await axios.delete(`/center/${id}`);
      return response.data;
  } catch (error) {
      // Manejo de errores con mensaje claro
      if (error.response && error.response.data) {
          // Incluye el mensaje y el estado en el error lanzado
          throw new Error(error.response.data.message || "Error desconocido del servidor");
      } else {
          // Lanza un error genérico si no hay respuesta del backend
          throw new Error("Error de conexión con el servidor");
      }
  }
},




//  Funciones del departamento   

 // Agregar una nuevo centro
 async addDepartment(department) {
  try {
    const response = await axios.post('/department', department);
    this.departments.push(response.data); // Agregar la nueva empresa a la lista
  } catch (error) {
    console.error('Error adding center:', error.message);
    throw error;
  }
},

// Actualizar un centro
async updateDepartment(department) {
  try {
    const response = await axios.put(`/department/${department.id}`, department);
    // Actualizar la empresa en la lista
    const index = this.departments.findIndex((c) => c.id === department.id);
    if (index !== -1) {
      this.departments[index] = response.data;
    }
  } catch (error) {
    console.error('Error updating departments:', error.message);
    throw error;
  }
},


async deleteDepartment(id) {
  try {
      const response = await axios.delete(`/department/${id}`);
      return response.data;
  } catch (error) {
      // Manejo de errores con mensaje claro
      if (error.response && error.response.data) {
          // Incluye el mensaje y el estado en el error lanzado
          throw new Error(error.response.data.message || "Error desconocido del servidor");
      } else {
          // Lanza un error genérico si no hay respuesta del backend
          throw new Error("Error de conexión con el servidor");
      }
  }
}







  }

 })